module.exports = __webpack_public_path__ + "static/media/Roboto-CondensedItalic.7a1bd1c4.ttf";